<ng-container [formGroup]="formGroup">
    <td>
        <div class="checkbox-container">
            <input
                type="checkbox"
                class="form-control"
                #checkbox
                formControlName="checkbox"
                [attr.aria-label]="'RECIPIENT_LIST_SELECT_RECIPIENT_ARIA_LABEL' | translate"
            />
            @if (checkbox.checked) {
                <fa-icon [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
            }
        </div>
    </td>
    <td>
        <input
            type="email"
            class="form-control text-input"
            [placeholder]="emailPlaceHolder"
            formControlName="email"
            email="true"
        />
    </td>
    <td>
        <button
            type="button"
            class="btn btn-warning"
            [disabled]="!recipient.deletable"
            (click)="delete.emit()"
            [attr.aria-label]="'RECIPIENT_LIST_DELETE_RECIPIENT_ARIA_LABEL' | translate"
        >
            <fa-icon [icon]="faTrashAlt"></fa-icon>
        </button>
    </td>
</ng-container>
